//
// Generated class ManagerSectionLocalized
//

/// <reference path="ManagerSectionLocalized_ManagedObject.ts" />

class ManagerSectionLocalized extends ManagerSectionLocalized_ManagedObject
{

}
